import React, { useMemo } from 'react';
import { useTrekker } from 'utils/analytics';
import { useCurrencyContext } from '~/context/CurrencyContext';
import { useCurrenciesListContext } from '~/context/CurrencyListContext';
import SelectMenuItem from '~/reusable-components/navigation/NavigationMenuList/SelectMenuItem';

function CurrencyMenuItem() {
  const { state, actions } = useCurrencyContext();
  const { state: currenciesListState } = useCurrenciesListContext();
  const { currencies, loading } = currenciesListState;
  const trekker = useTrekker();

  const options = useMemo(() => {
    return currencies.map(({ symbol_native, code }) => ({
      value: code,
      label: `${code} - (${symbol_native})`,
    }));
  }, [currencies]);

  const handleClick = () => {
    trekker.event('click', {
      component: ['CurrencySwitch'],
      target: 'Menu',
      action: 'open currency switch',
    });
  };

  const onCurrencyChange = (newValue) => {
    if (newValue !== state.currency) {
      actions.setCurrency(newValue);
      trekker.event('click', {
        component: ['CurrencySwitch'],
        target: 'Menu',
        action: `change ${state.currency} to ${newValue}`,
      });
    }
  };

  if (loading || options.length === 0) {
    return null; // Or you could render a loading state or placeholder
  }

  return (
    <SelectMenuItem
      selectedItem={state.currency}
      options={options}
      onSelect={onCurrencyChange}
      onClick={handleClick}
      label="Currency"
    />
  );
}

export default CurrencyMenuItem;
